import defaultBanner from "./defaultBanner";
import { getTodayDate, getDisplayTime } from "./date";

export const parseBody = (text) => {
  var newL = /\n/g;
  return text.replace(newL, "<br/>");
};

export const getVenueDetails = (data) => {
  if (data.eventType === "virtual") {
    return {
      zoomLink: data.zoomLink,
      meetingId: data.meetingId,
      passcode: data.passcode,
    };
  } else {
    return {
      address: data.address,
      placeName: data.placeName,
    };
  }
};

//Sep 12 2021. 12: 11AM - 12: 14AM
//let datStr = month + " " + date + " " + year + ", " + startTime + " - " + endTime

export const parseEventPayload = (data, id, imageChanged, docChanged) => {
  let payload = {
    title: data.title,
    maxNoOfGuests: data.maxNoOfGuests,
    maxAdditionalGuests: data.maxAdditionalGuests,
    ctaText: data.ctaText,
    messageTitle: data.messageTitle,
    message: data.message,
    eventType: data.eventType,
    propertyId: data.propertyId,
    startAt: data.startAt.toISOString(),
    endAt: data.endAt.toISOString(),
    ...(!id || (id && imageChanged) ? { imageData: data.imageData } : {}),
    ...(!id || (id && docChanged) ? { docData: data.docData } : {}),
    ...getVenueDetails(data),
    displayTime: getDisplayTime(data.startAt, data.endAt),
    fields: data.leadFields.length > 0 ? data.leadFields : "",
    rsvpFormHeader: data.rsvpFormHeader,
    recurringEventType: data.recurringEventType,
    repeatType: data.repeatType,
    recurrenceType: data.recurrenceType,
    recurrenceEndDate: data.recurrenceEndDate,
    recurringDaysList: data.recurringDaysList,
    pdfFileName: data.pdfFileName,
  };

  if (id) payload.id = id;
  return payload;
};

export const brToNl = (str, replaceMode) => {
  var replaceStr = replaceMode ? "\n" : "";
  // Includes <br>, <BR>, <br />, </br>
  str = str.replace(/<\s*\/?br\s*[\/]?>/gi, "\n");
  return str.replace(/(<([^>]+)>)/gi, "");
};

export const parseAddress = (address) => {
  let addressStr;
  if (address) {
    const addressDetails = JSON.parse(address);
    addressStr =
      addressDetails.address +
      ", " +
      addressDetails.city +
      ", " +
      addressDetails.state +
      " " +
      addressDetails.zip +
      ", " +
      addressDetails.country;
  }
  return addressStr;
};

export const getDefaultValues = (props) => {
  const { startAt, endAt } = getTodayDate(props.timezoneString);

  return {
    title: props.title,
    maxNoOfGuests: 30,
    maxAdditionalGuests: 0,
    ctaText: "RSVP",
    messageTitle: props.subtitle,
    message: props.message,
    address:
      parseAddress(props.address) ||
      "20 Massachusetts Ave NW, Washington, DC 20001, USA",
    placeName: props.name || "The Clubhouse",
    startAt: startAt,
    endAt: endAt,
    imageData: props.imageData || defaultBanner,
    inviteEmailCampaignId: props.inviteEmailCampaignId,
    approverName: props.approverName,
    disapproveReason: props.disapproveReason,
    eventType: "in_person",
    docData: null,
    pdfFileName: "",
    rsvpFormHeader: "Join Us",
    leadFields: [],
    recurringEventType: "non_recurring",
  };
};

export const sortContactGroups = (contactGroups) => {
  let local = [];
  let findBy = ["Prospect", "Resident", "Broker"];
  for (var i = 0; i < 3; i++) {
    let listItem = contactGroups.find((e) => e.name === findBy[i]);
    if (listItem) {
      local.push(listItem);
    }
  }
  return local;
};
